import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

/** Pinta um SVG estático com a cor do texto (currentColor) via máscara CSS. */
export function MaskedSvgIcon({
  src,
  className,
}: {
  src: string;
  className?: string;
}) {
  return (
    <span
      className={cn('inline-block shrink-0 bg-current', className)}
      style={{
        maskImage: `url(${src})`,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskImage: `url(${src})`,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
      }}
      aria-hidden
    />
  );
}

function createMaskedNavIcon(src: string): LucideIcon {
  function NavIcon({ className }: { className?: string }) {
    return <MaskedSvgIcon src={src} className={className} />;
  }
  return NavIcon as LucideIcon;
}

/** Ícones do sidemenu do painel (public/icons). */
export const PowerNavIcon = createMaskedNavIcon('/icons/power.svg');
export const EquipeNavIcon = createMaskedNavIcon('/icons/equipe.svg');
export const PawnNavIcon = createMaskedNavIcon('/icons/pawn.svg');
export const SmileNavIcon = createMaskedNavIcon('/icons/smile.svg');
export const AceNavIcon = createMaskedNavIcon('/icons/ace.svg');
export const UserConfigNavIcon = createMaskedNavIcon('/icons/userconfig.svg');
export const UserNavIcon = createMaskedNavIcon('/icons/user.svg');
export const UserMoreNavIcon = createMaskedNavIcon('/icons/usermore.svg');
export const PowerCategoryNavIcon = createMaskedNavIcon('/icons/power2.svg');
